import { render, staticRenderFns } from "./RecordNameVoting.vue?vue&type=template&id=080e7ece&scoped=true"
import script from "./RecordNameVoting.vue?vue&type=script&lang=js"
export * from "./RecordNameVoting.vue?vue&type=script&lang=js"
import style0 from "./RecordNameVoting.vue?vue&type=style&index=0&id=080e7ece&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e7ece",
  null
  
)

export default component.exports